<template>
  <hm-content title="">
    <div class="table-panel flex flex-start">
      <el-button type="primary" size="small" @click="add">新增发货商</el-button>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="supplierName"
          label="发货商名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="contactPhone"
          label="联系电话"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="supplierCode"
          label="发货商编码"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="expressRemark"
          label="发货说明"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                @click="edit(scope.row)"
                class="blue"
                >编辑</el-button
              >
              <!-- <el-button
                size="small"
                type="text"
                @click="del(scope.row)"
                class="danger"
                >删除</el-button
              > -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      @close="dialogVisible = false"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="发货商编号" prop="supplierCode">
          <el-input
            clearable
            maxlength="20"
            @mousewheel.prevent.native
            v-model.trim="ruleForm.supplierCode"
            placeholder="自动生成发货商编号"
            size="small"
            class="ipt mr10"
            :disabled='true'
          ></el-input>
          <!-- <div class="form-item-tip">
            自动生成
          </div> -->
        </el-form-item>
        <el-form-item label="发货商名称" prop="supplierName">
          <el-input
            clearable
            maxlength="50"
            @mousewheel.prevent.native
            v-model.trim="ruleForm.supplierName"
            placeholder="请输入发货商名称"
            size="small"
            class="ipt mr10"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input
            clearable
            @mousewheel.prevent.native
            v-model.trim="ruleForm.contactPhone"
            placeholder="请输入发货商联系电话"
            size="small"
            class="ipt mr10"
          ></el-input>
        </el-form-item>
        <el-form-item label="说明" prop="expressRemark">
          <el-input
            clearable
            class="mr10"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 17 }"
            maxlength="130"
            v-model.trim="ruleForm.expressRemark"
            placeholder="请输入说明"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitForm('ruleForm')" size="small" type="primary"
          >确 认</el-button
        >
        <el-button @click="handleClose" size="small">取 消</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      title: "",
      ruleForm: {
        supplierCode: "",
        supplierName: "",
        contactPhone: "",
        expressRemark: ""
      },
      rules: {
        supplierName: {
          required: true,
          message: "请输入发货商名称",
          trigger: "blur"
        },
        contactPhone: {
          required: false,
          pattern: /^1[0-9]{10}$/,
          message: "请输入正确的手机号",
          trigger: "blur"
        }
      },
      operate: "",
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.resetRuleForm();
    },
    resetRuleForm() {
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
      }, 0);
    },
    edit(row) {
      this.operate = "edit";
      this.title = "编辑发货商";
      this.dialogVisible = true;
      this.$store
        .dispatch("detailsSupplierInfo", { supplierId: row.supplierId })
        .then(res => {
          for (let key in this.ruleForm) {
            this.ruleForm[key] = res.result[key];
          }
          if (this.operate === "edit") {
            this.ruleForm.supplierId = res.result.supplierId;
          }
        });
    },
    del(row) {
      this.$confirm(" 是否确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("delSupplierInfo", { supplierId: row.supplierId })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    },
    add() {
      this.operate = "add";
      this.title = "新增发货商";
      this.dialogVisible = true;
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };

      const { result } = await this.$store.dispatch(
        "querySupplierInfoList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = this.ruleForm;
        let name =
          this.operate === "add" ? "saveSupplierInfo" : "editSupplierInfo";

        const { code } = await this.$store.dispatch(name, params);
        if (code === "0") {
          this.$message({
            type: "success",
            message: "操作成功"
          });

          this.resetRuleForm(formName);

          this.dialogVisible = false;
          this.queryList();
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
